/// <reference path="../../typings/tsd.d.ts" />
module warsApp.models {
    declare var emailNotificationActionSelf: EmailNotificationModel;

    export class EmailNotificationModel {
        public emails: Wars.Domain.Model.Dtos.EmailDto[];
        public filteredEmails: Wars.Domain.Model.Dtos.EmailDto[];
        public tinyMceOptions: any;
        public filters = {
            createdDateString: '',
            subject: '',
            processName: ''
        }
        public sorted = {
            value: 'createdDate',
            ascending: false
        }
        public paging = {
            currentPage: 1,
            pageSize: 10,
            goToPage: 1
        }
        public search = {
            createDateBegin: moment().startOf('day').subtract(30, 'days').toDate(),
            createDateEnd: '',//moment().endOf('day').toDate(),
            subject: '',
            body: '',
            processName: ''
        }
        public searchOptions = {
            maxDate: new Date(),
            readonlyInput: false,
            showMeridian: true
        }

        constructor(
            private scope: angular.IScope,
            private $rootScope: angular.IRootScopeService,
            private $timeout: ng.ITimeoutService,
            private $filter: ng.IFilterService,
            private growlService: angular.growl.IGrowlService,
            private emailService: services.EmailService) {
            emailNotificationActionSelf = this;
            emailNotificationActionSelf.emails = [];
            emailNotificationActionSelf.searchOptions.maxDate = new Date(emailNotificationActionSelf.searchOptions.maxDate.getFullYear(),
                emailNotificationActionSelf.searchOptions.maxDate.getMonth(),
                emailNotificationActionSelf.searchOptions.maxDate.getDate());
            //emailNotificationActionSelf.search.createDateBegin = emailNotificationActionSelf.searchOptions.maxDate;
            emailNotificationActionSelf.emailService.getEmails(emailNotificationActionSelf.search)
                .then(returnEmail => {
                    if (returnEmail.length > 0) {
                        emailNotificationActionSelf.emails = returnEmail;
                        emailNotificationActionSelf.emails.forEach(setup => {
                            setup.createdDateString = moment.utc(setup.createdDate).local().format('MMMM Do YYYY, h:mm a').toString();
                            setup.sentDateTimeString = moment.utc(setup.sentDateTime).local().format('MMMM Do YYYY, h:mm a').toString();
                        });

                        emailNotificationActionSelf.filteredEmails = emailNotificationActionSelf.emails;
                        var viewedNotifications = Enumerable.from(emailNotificationActionSelf.emails)
                            .where(f => f.viewed === false)
                            .toArray();
                        if (viewedNotifications.length > 0) {
                            //emailNotificationActionSelf.$timeout(() => {
                            emailNotificationActionSelf.emailService
                                .updateViewedNotifications(viewedNotifications)
                                .then(() => {
                                    emailNotificationActionSelf.$rootScope.$broadcast('notificationCountRefresh', 0);
                                    viewedNotifications.forEach(i => {
                                        i.viewed = true;
                                    });
                                });
                            //},
                            //    2000);
                        }
                    } else {
                        emailNotificationActionSelf.growlService.error("No emails match your criteria.");
                    }
                });
            emailNotificationActionSelf.tinyMceOptions = {
                format: 'raw',
                menubar: false,
                statusbar: false,
                toolbar: false,
                height: 100,
                plugins: "noneditable",
                readonly: 1,
                content_css: "content/mce.css"
            };
        }

        public sort(val: string) {
            if (emailNotificationActionSelf.sorted.value === val) {
                emailNotificationActionSelf.sorted.ascending = !emailNotificationActionSelf.sorted.ascending;
            } else {
                emailNotificationActionSelf.sorted.value = val;
                emailNotificationActionSelf.sorted.ascending = true;
            }
        }

        public filterEmails() {
            emailNotificationActionSelf.paging.currentPage = 1;
            emailNotificationActionSelf.paging.goToPage = 1;
            emailNotificationActionSelf.filteredEmails = emailNotificationActionSelf.$filter('filter')(emailNotificationActionSelf.emails,
                {
                    createdDateString: emailNotificationActionSelf.filters.createdDateString,
                    subject: emailNotificationActionSelf.filters.subject,
                    processName: emailNotificationActionSelf.filters.processName
                });
        }

        public getTotalPages() {
            if (!emailNotificationActionSelf.filteredEmails) return 0;
            return emailNotificationActionSelf.filteredEmails.length > 0 ? Math.ceil(emailNotificationActionSelf.filteredEmails.length / emailNotificationActionSelf.paging.pageSize) : 1;
        }

        public setCurrentPage() {
            if (emailNotificationActionSelf.paging.goToPage > 0 && emailNotificationActionSelf.paging.goToPage <= emailNotificationActionSelf.getTotalPages()) {
                emailNotificationActionSelf.paging.currentPage = emailNotificationActionSelf.paging.goToPage;
            }
        }

        public searchEmails() {
            emailNotificationActionSelf.emailService.getEmails(emailNotificationActionSelf.search)
                .then((emails) => {
                    if (emails.length > 0) {
                        emailNotificationActionSelf.emails = emails;
                        emailNotificationActionSelf.filteredEmails = emailNotificationActionSelf.emails;
                    } else {
                        emailNotificationActionSelf.growlService.error("No emails match your criteria.");
                    }
                });
        }
    }
}